import { connect } from "react-redux";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { Checkbox } from "material-ui";
import ReportDefinitions from "../../../common/config/ReportDefinitions";
import ProgressButtons from "./ProgressButtons";
import {
  getCheckedFilterOnDespatch,
  getCheckedFilterOnImpc,
  getCheckedFilterOnItems,
  getCheckedOnlyShowItems,
  getCheckedOnlyShowItemsWith,
  getManualEntryText,
  getSpaceSeparatedSuffixes,
} from "../../target-node-item-criteria-selector/redux/selectors/ItemCriteriaSelector";
import SelectionCriteriaItemSelector from "../../target-node-item-criteria-selector/components/SelectionCriteriaItemSelector";
import {
  getPeriodSelectorEndDate,
  getPeriodSelectorStartDate,
} from "../../period-selector/redux/selectors/PeriodSelectionSelectors";
import {
  filterOnDespatchCheckedActionCreator,
  filterOnIMPCCheckedActionCreator,
  filterOnItemCheckedActionCreator,
  filterOnManualEntryActionCreator,
  onlyShowItemCheckedActionCreator,
  onlyShowItemWithCheckedActionCreator,
  spaceSeparatedSuffixesActionCreator,
} from "../../target-node-item-criteria-selector/redux/actions/ItemCriteriaActions";
import sc from "../../../common/redux/actions/types/SelectionCriteriaTypes";
/* eslint-disable import/no-cycle */
import scDefinitions from "../../../common/config/SelectionCriteriaDefinitions";
import {
  onArrivalPostalOperatorExpanded,
  onDeSelectAllArrivalMailProcessingCenters,
} from "../../target-node-impc-selector/redux/actions/ArrivalPostalOperatorActions";
import {
  onDeparturePostalOperatorExpanded,
  onDeSelectAllDepartureMailProcessingCenters,
} from "../../target-node-impc-selector/redux/actions/DeparturePostalOperatorActions";
import {
  FILTER_ITEM_NODES,
  getAllItemOptions,
  getWithItemOptions,
} from "../utils/ItemOptionsUtils";

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      filterOnItemCheckedActionCreator,
      onlyShowItemCheckedActionCreator,
      onlyShowItemWithCheckedActionCreator,
      filterOnIMPCCheckedActionCreator,
      filterOnDespatchCheckedActionCreator,
      filterOnManualEntryActionCreator,
      spaceSeparatedSuffixesActionCreator,
      onDeSelectAllArrivalMailProcessingCenters,
      onDeSelectAllDepartureMailProcessingCenters,
      onArrivalPostalOperatorExpanded,
      onDeparturePostalOperatorExpanded,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  checkedFilterOnItems: getCheckedFilterOnItems(state),
  checkedOnlyShowItems: getCheckedOnlyShowItems(state),
  checkedOnlyShowItemsWith: getCheckedOnlyShowItemsWith(state),
  checkedSelectFilterOnImpc: getCheckedFilterOnImpc(state),
  checkedSelectFilterOnDespatch: getCheckedFilterOnDespatch(state),
  startDate: getPeriodSelectorStartDate(state),
  endDate: getPeriodSelectorEndDate(state),
  manuelEntryText: getManualEntryText(state),
  spaceSeparatedSuffixes: getSpaceSeparatedSuffixes(state),
});

// eslint-disable-next-line react/prefer-stateless-function
export class TargetNodeItemCriteriaWizardContainer extends Component {
  onSelectFilterOnItem = (filterOnItemNodes) => (selected) => {
    this.props.filterOnItemCheckedActionCreator(filterOnItemNodes, selected);
  };

  onSelectOnlyShowItems = (onlyShowItemsNodes, onlyShowItemsWithNodes) => (
    selected
  ) => {
    this.props.onlyShowItemCheckedActionCreator(onlyShowItemsNodes, selected);
    // Remove any items that are now selected in "missing" from the "with" filter (item-level mutual exclusivity)
    if (selected.length > 0) {
      const currentWithItems = this.props.checkedOnlyShowItemsWith || [];
      const updatedWithItems = currentWithItems.filter(
        (item) => !selected.includes(item)
      );
      if (updatedWithItems.length !== currentWithItems.length) {
        this.props.onlyShowItemWithCheckedActionCreator(
          onlyShowItemsWithNodes,
          updatedWithItems
        );
      }
    }
  };

  onSelectOnlyShowItemsWith = (onlyShowItemsWithNodes, onlyShowItemsNodes) => (
    selected
  ) => {
    this.props.onlyShowItemWithCheckedActionCreator(
      onlyShowItemsWithNodes,
      selected
    );
    // Remove any items that are now selected in "with" from the "missing" filter (item-level mutual exclusivity)
    if (selected.length > 0) {
      const currentMissingItems = this.props.checkedOnlyShowItems || [];
      const updatedMissingItems = currentMissingItems.filter(
        (item) => !selected.includes(item)
      );
      if (updatedMissingItems.length !== currentMissingItems.length) {
        this.props.onlyShowItemCheckedActionCreator(
          onlyShowItemsNodes,
          updatedMissingItems
        );
      }
    }
  };

  onSelectFilterOnImpc = (event) => {
    const { id } = this.props.children.report;
    this.props.filterOnIMPCCheckedActionCreator(event.target.checked);
    // eslint-disable-next-line no-unused-vars
    const scItem = this.props.children.report.selectionCriteria.items;
    if (event.target.checked) {
      ReportDefinitions[id].locationType = "IMPC";
    } else {
      this.props.onDeSelectAllArrivalMailProcessingCenters();
      this.props.onDeSelectAllDepartureMailProcessingCenters();
      this.props.onArrivalPostalOperatorExpanded([]);
      this.props.onDeparturePostalOperatorExpanded([]);
      ReportDefinitions[id].locationType = "OPERATOR";
    }
  };

  onSelectFilterOnDespatchType = (event) => {
    this.props.filterOnDespatchCheckedActionCreator(event.target.checked);
    // if (event.target.checked) {
    //   this.props.selectAllCategories();
    // }
  };

  onSpaceSeperatedTextChange = (event) => {
    this.props.filterOnManualEntryActionCreator(event.target.value);
  };

  onSpaceSeparatedSuffixesChange = (event) => {
    this.props.spaceSeparatedSuffixesActionCreator(event.target.value);
  };

  render() {
    const selectionCriteria =
      this.props.children.report.selectionCriteria.items;
    const SC_CODE = selectionCriteria.includes(sc.SC100_OVERVIEW)
      ? sc.SC100_OVERVIEW
      : sc.SC100;

    const reportId = this.props.children.report.id;
    const allItemOptions = getAllItemOptions(SC_CODE, reportId);
    const withItemOptions = getWithItemOptions(SC_CODE, reportId);
    const nextSelectionCriteriaRouteName = (
      scDefinitions[
        selectionCriteria[selectionCriteria.indexOf(SC_CODE) + 1]
      ] || {}
    ).routeName;
    const text = "(Manual entry):\nEnter multiple values space separated";
    /* eslint-disable react/jsx-indent */
    return (
      <div className="operator-selector-wrapper">
        <div className="operators">
          <div className="operators-selection-panel">
            <div className="operator">
              <div className="item-criteria-table">
                <div className="item-filter-div">
                  <div className="item-title">
                    Filter on Item ID prefix/Service indicator
                  </div>
                  <SelectionCriteriaItemSelector
                    itemNodes={FILTER_ITEM_NODES}
                    onSelect={this.onSelectFilterOnItem(FILTER_ITEM_NODES)}
                    selected={this.props.checkedFilterOnItems}
                  />
                </div>
                <div className="item-filter-div">
                  <div className="item-title">
                    {text.split("\n").map((i, key) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <div key={key}>{i}</div>
                    ))}
                  </div>
                  <textarea
                    className="seperated-input"
                    cols="58"
                    rows="7"
                    onChange={this.onSpaceSeperatedTextChange}
                    placeholder="Filter on Item IDs:&#10;Enter multiple values separated by a space (e.g. X Y Z). X, Y and Z can be one or multiple letter(s) or number(s) (e.g. multiple full item IDs separated by spaces are allowed). Multiple conditions separated by a space will be treated as an OR, the report will then show all data meeting one of the conditions (e.g. CA CX U: will show all Item IDs starting with CA, OR starting with CX, OR starting with U)."
                    defaultValue={this.props.manuelEntryText}
                    style={{
                      padding: "8px",
                    }}
                  />
                </div>
                {SC_CODE === sc.SC100_OVERVIEW && (
                  <div
                    className="item-filter-div"
                    style={{ marginTop: "10px" }}
                  >
                    <div className="item-title">Filter on Item ID suffix</div>
                    <input
                      type="text"
                      className="seperated-input"
                      placeholder="Two characters code, e.g country code"
                      value={this.props.spaceSeparatedSuffixes}
                      onChange={this.onSpaceSeparatedSuffixesChange}
                      maxLength="160"
                      style={{
                        padding: "8px",
                        border: "1px solid ",
                        borderRadius: "2px",
                        width: "451px",
                      }}
                    />
                  </div>
                )}
                <div className="item-filter-div">
                  <div className="item-title">Filter on IMPC(s)</div>
                  <Checkbox
                    style={{
                      width: "40px",
                      transform: "scale(0.7)",
                      marginLeft: "21px",
                    }}
                    onCheck={this.onSelectFilterOnImpc}
                    checked={this.props.checkedSelectFilterOnImpc}
                  />
                </div>
                <div className="item-filter-div">
                  <div className="item-title">Filter on despatch type(s)</div>
                  <Checkbox
                    style={{
                      width: "40px",
                      transform: "scale(0.7)",
                      marginLeft: "21px",
                    }}
                    onCheck={this.onSelectFilterOnDespatchType}
                    checked={this.props.checkedSelectFilterOnDespatch}
                  />
                </div>
                <div
                  className="item-filter-div"
                  style={{ marginBottom: "20px" }}
                >
                  <div className="item-title">Only show items with missing</div>
                  <div className="item-options-grid-container">
                    <SelectionCriteriaItemSelector
                      itemNodes={allItemOptions}
                      onSelect={this.onSelectOnlyShowItems(
                        allItemOptions,
                        withItemOptions
                      )}
                      selected={this.props.checkedOnlyShowItems}
                    />
                  </div>
                </div>
                {SC_CODE === sc.SC100_OVERVIEW && (
                  <div className="item-filter-div">
                    <div className="item-title">Only show items with</div>
                    <div className="item-options-grid-container">
                      <SelectionCriteriaItemSelector
                        itemNodes={withItemOptions}
                        onSelect={this.onSelectOnlyShowItemsWith(
                          withItemOptions,
                          allItemOptions
                        )}
                        selected={this.props.checkedOnlyShowItemsWith}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="actions">
            <ProgressButtons
              next={this.props.children.routes[nextSelectionCriteriaRouteName]}
            />
          </div>
        </div>
      </div>
    );
  }
}

TargetNodeItemCriteriaWizardContainer.propTypes = {
  report: PropTypes.shape({
    selectionCriteria: PropTypes.objectOf(PropTypes.shape),
    reportDirections: PropTypes.arrayOf(PropTypes.string),
    locationType: PropTypes.string,
    id: PropTypes.string,
  }),
  routes: PropTypes.objectOf(PropTypes.shape).isRequired,
  checkedFilterOnItems: PropTypes.arrayOf(PropTypes.string),
  checkedSelectFilterOnImpc: PropTypes.bool,
  checkedSelectFilterOnDespatch: PropTypes.bool,
  checkedOnlyShowItems: PropTypes.arrayOf(PropTypes.string),
  checkedOnlyShowItemsWith: PropTypes.arrayOf(PropTypes.string),
  manuelEntryText: PropTypes.string,
  spaceSeparatedSuffixes: PropTypes.string,
  filterOnItemCheckedActionCreator: PropTypes.func,
  onlyShowItemCheckedActionCreator: PropTypes.func,
  onlyShowItemWithCheckedActionCreator: PropTypes.func,
  filterOnIMPCCheckedActionCreator: PropTypes.func,
  filterOnDespatchCheckedActionCreator: PropTypes.func,
  filterOnManualEntryActionCreator: PropTypes.func,
  spaceSeparatedSuffixesActionCreator: PropTypes.func,
  onDeSelectAllArrivalMailProcessingCenters: PropTypes.func,
  onDeSelectAllDepartureMailProcessingCenters: PropTypes.func,
  onArrivalPostalOperatorExpanded: PropTypes.func,
  onDeparturePostalOperatorExpanded: PropTypes.func,
};

/* Needed for prop-types with cloneElement */
export const ConnectedTTargetNodeItemCriteriaWizardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TargetNodeItemCriteriaWizardContainer);

export default ConnectedTTargetNodeItemCriteriaWizardContainer;
